import { render, staticRenderFns } from "./ShopInfoForm.vue?vue&type=template&id=c5e6b130&scoped=true"
import script from "./ShopInfoForm.vue?vue&type=script&lang=js"
export * from "./ShopInfoForm.vue?vue&type=script&lang=js"
import style0 from "./ShopInfoForm.vue?vue&type=style&index=0&id=c5e6b130&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5e6b130",
  null
  
)

export default component.exports